export const getURLDomainName = (url: string) => {
    try {
        const urlObject = new URL(url);
        return urlObject.host;
    } catch {
        // return current AMC domain name if URL is not a properly form URL or empty
        return window.location.host;
    }
};
